import type { ProgramTheme } from "@/lib/content/types"

/** App config sourced from Vite mode env files (`.env.dev` / `.env.sit` / `.env.production`). */
const FALLBACK_APPLICATION_PORTAL_URL = "https://scholarshipdev.jio.com/"
const FALLBACK_APPLY_PORTAL_URL = "https://scholarshipdev.jio.com/RegisterScholar"

export const env = {
  applicationPortalUrl:
    import.meta.env.VITE_APPLICATION_PORTAL_URL || FALLBACK_APPLICATION_PORTAL_URL,
  applyPortalUrl: import.meta.env.VITE_APPLY_PORTAL_URL || FALLBACK_APPLY_PORTAL_URL,
} as const

/** Apply portal URL with program hash (`#ug` / `#pg`). */
export function getApplyPortalUrl(theme: ProgramTheme): string {
  const base = env.applyPortalUrl.replace(/#.*$/, "")
  return `${base}#${theme === "UG" ? "ug" : "pg"}`
}
